import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Paper } from "../Paper";

interface StyledCardProps {
  $pointer?: boolean;
}

export const StyledCard = styled(Paper)<StyledCardProps>`
  ${tw`tw-text-theme-900`}

  ${({ $pointer }) =>
    $pointer &&
    css`
      cursor: pointer;
    `}
`;

StyledCard.displayName = "StyledCard";
